import React from 'react';
import Header from './components/Header';
import * as Images from '../assets';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
} from '@mui/material';
import { ArrowRight } from '@mui/icons-material';

const TermsAndConditions = () => {
  return (
    <div>
      {/* <Header page="terms&conditions" /> */}
      <div
        className="md:px-8 px-2 md:py-12 py-8"
        style={{
          backgroundImage: `url('${Images.homePage8}')`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
          transition:
            'background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s',
        }}
      >
        <div className="flex justify-center">
          <div className="lg:w-[80%] md:w-[80%] sm:w-[90%] w-[100%]">
            <div className="md:px-16 md:py-20 px-6 py-10 ">
              <div className="flex flex-col gap-8 items-center container mx-auto">
                <div className="text-sm">
                  Users of the Tender Notice Board (TNB) must agree to comply
                  with all the following Terms and Conditions. Throughout these
                  Terms and Conditions, ‘Tender Notice Board’ and ‘we/us/our’
                  means Tender Notice Board, which is part of Global eSourcing,
                  Stensballegaardvej 23, 8700 Horsens, Denmark, CVR company
                  number 37252867.
                </div>

                <div>
                  <Accordion
                    disableGutters
                    sx={{
                      backgroundColor: 'transparent',
                      boxShadow: 'none',
                      borderBottom: '1px solid #990',
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ArrowRight />}
                      sx={{
                        flexDirection: 'row-reverse', // Moves the expand icon to the left
                      }}
                      aria-controls="panel1-content"
                      id="panel1-header"
                      className="font-semibold"
                    >
                      Copyright
                    </AccordionSummary>
                    <AccordionDetails className="text-sm">
                      All the design, text, graphics, software compilations,
                      underlying source code, software (including applets) and
                      other material on this website are the copyright of Tender
                      Notice Board and our affiliates, or our content and
                      technology providers. All rights reserved. You may only
                      electronically copy and print hard copy parts of this
                      website in order to subscribe to Tender Notice Board. Any
                      other use (including: reproduction for other purposes;
                      modification; distribution or publication) without our
                      prior written permission is strictly prohibited.
                    </AccordionDetails>
                  </Accordion>
                  <Accordion
                    disableGutters
                    sx={{
                      backgroundColor: 'transparent',
                      boxShadow: 'none',
                      borderBottom: '1px solid #990',
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ArrowRight />}
                      sx={{
                        flexDirection: 'row-reverse', // Moves the expand icon to the left
                      }}
                      aria-controls="panel2-content"
                      id="panel2-header"
                      className="font-semibold"
                    >
                      Disclaimer
                    </AccordionSummary>
                    <AccordionDetails className="text-sm">
                      To the fullest extent permitted at law, we provide this
                      website and its contents on an ‘as is’ basis. We make no
                      (and expressly disclaim all) representations or warranties
                      of any kind with respect to this website or its contents,
                      including, without limitation, warranties of
                      merchantability and fitness for a particular purpose. In
                      addition, we do not represent or warrant that the
                      information accessible via this website is accurate,
                      complete or current. Except as specifically stated on this
                      website, to the fullest extent permitted at law, neither
                      Tender Notice Board nor any of its affiliates, directors,
                      employees or other representatives will be liable for
                      damages arising out of or in connection with using this
                      website. This is a comprehensive limitation of liability
                      that applies to all damages of any kind, including
                      (without limitation) compensatory, direct, indirect or
                      consequential damages, loss of data, income or profit,
                      loss of or damage to property and claims of third parties.
                      For the avoidance of doubt, Tender Notice Board does not
                      limit its liability for death or personal injury to the
                      extent only that it arises as a result of the negligence
                      of Tender Notice Board, its affiliates, directors,
                      employees or other representatives.
                    </AccordionDetails>
                  </Accordion>
                  <Accordion
                    disableGutters
                    sx={{
                      backgroundColor: 'transparent',
                      boxShadow: 'none',
                      borderBottom: '1px solid #990',
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ArrowRight />}
                      sx={{
                        flexDirection: 'row-reverse', // Moves the expand icon to the left
                      }}
                      aria-controls="panel3-content"
                      id="panel3-header"
                      className="font-semibold"
                    >
                      Links to third party sites
                    </AccordionSummary>
                    <AccordionDetails className="text-sm">
                      This website contains links to other websites that we do
                      not control or maintain. We are not responsible for the
                      content of these sites. We provide these links for your
                      convenience only, and do not necessarily endorse their
                      content.
                    </AccordionDetails>
                  </Accordion>
                  <Accordion
                    disableGutters
                    sx={{
                      backgroundColor: 'transparent',
                      boxShadow: 'none',
                      borderBottom: '1px solid #990',
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ArrowRight />}
                      sx={{
                        flexDirection: 'row-reverse', // Moves the expand icon to the left
                      }}
                      aria-controls="panel4-content"
                      id="panel4-header"
                      className="font-semibold"
                    >
                      Data protection and privacy
                    </AccordionSummary>
                    <AccordionDetails className="text-sm">
                      Any details you give us, and from which we can identify
                      you, are held and processed in accordance with our Privacy
                      Policy. <br />
                      We collect and use your personal data in accordance with
                      our privacy policy which can be found below. We may update
                      the policy from time to time so we recommend that you
                      revisit the page from time to time to stay informed about
                      how we use your information.
                    </AccordionDetails>
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
